import { Fragment } from "react";
import "./css/disclaimer.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Construccion from "../../images/assets/disclaimer.png";

function InfoDisclaimer() {
  return (
    <Fragment>
      <div className="disclaimer-cont">
        <Container>
          <Row>
            <Col md={12} className="text-center mb-3 mb-5">
              <h1 className="disclaimer-titulo">Página en construcción</h1>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Image src={Construccion} alt="Hyundai disclaimer" fluid />
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}
export default InfoDisclaimer;